module.exports = __webpack_public_path__ + "img/featureSlide03Img.82ba8f59.png";